import { useTranslation } from "react-i18next";

const ImpressumPage = () => {
  const { t } = useTranslation("marketing");

  return (
    <div>
      <section className="container py-16 md:py-24">
        <div className="mx-auto max-w-3xl">
          <h1 className="mb-10 text-center text-4xl font-bold tracking-tight">
            {t("impressum.title")}
          </h1>

          <div className="space-y-8 leading-relaxed text-muted-foreground">
            {/* Angaben gemaess TMG Paragraph 5 */}
            <div>
              <h2 className="mb-2 text-lg font-semibold text-foreground">
                {t("impressum.tmgHeading")}
              </h2>
              <p>
                4T - Treidler Beratungs- &amp; Beteiligungsgesellschaft mbH
                <br />
                Ziegenpfad 10
                <br />
                22549 Hamburg
              </p>
            </div>

            {/* Handelsregister */}
            <div>
              <h2 className="mb-2 text-lg font-semibold text-foreground">
                {t("impressum.handelsregisterHeading")}
              </h2>
              <p>
                {t("impressum.handelsregisterBody")}
                <br />
                Steuernummer: 41/761/03603
              </p>
            </div>

            {/* Vertretungsberechtigt */}
            <div>
              <h2 className="mb-2 text-lg font-semibold text-foreground">
                {t("impressum.ceoHeading")}
              </h2>
              <p>Julian Treidler</p>
            </div>

            {/* Kontakt */}
            <div>
              <h2 className="mb-2 text-lg font-semibold text-foreground">
                {t("impressum.contactHeading")}
              </h2>
              <p>
                {t("impressum.contactEmail")}{" "}
                <a
                  href="mailto:info@firmenfinden.org"
                  className="text-primary hover:underline"
                >
                  info@firmenfinden.org
                </a>
                <br />
                {t("impressum.contactPhone")}
              </p>
            </div>

            {/* Umsatzsteuer */}
            <div>
              <h2 className="mb-2 text-lg font-semibold text-foreground">
                {t("impressum.vatHeading")}
              </h2>
              <p>{t("impressum.vatBody")}</p>
            </div>

            {/* Verantwortlich fuer den Inhalt */}
            <div>
              <h2 className="mb-2 text-lg font-semibold text-foreground">
                {t("impressum.responsibleHeading")}
              </h2>
              <p>
                Julian Treidler
                <br />
                Ziegenpfad 10
                <br />
                22549 Hamburg
              </p>
            </div>

            {/* Streitschlichtung */}
            <div>
              <h2 className="mb-2 text-lg font-semibold text-foreground">
                {t("impressum.disputeHeading")}
              </h2>
              <p>
                {t("impressum.disputeBody")}{" "}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:underline"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p className="mt-2">{t("impressum.disputeNoObligation")}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ImpressumPage;
